export const gatewaysZoom2Data = [
  {
    id: "1.32.3.202",
    type: "default",
    position: { x: 1875, y: 1000 },
    className: "gateway",
    data: { label: "147.32.3.202" },
    dragHandle: "noDrag",
  },
  {
    id: "147.32.3.202",
    type: "default",
    position: { x: 175, y: 190 },
    className: "gateway",
    data: { label: "147.32.3.202" },
    dragHandle: "noDrag",
  },
  {
    id: "91.198.174.192",
    type: "default",
    position: { x: 300, y: 240 },
    className: "gateway",
    data: { label: "91.198.174.192" },
    dragHandle: "noDrag",
  },
  {
    id: "2001:1488:0:3::2",
    type: "default",
    position: { x: 100, y: 470 },
    className: "gateway",
    data: { label: "2001:1488:0:3::2" },
    dragHandle: "noDrag",
  },
  {
    id: "193.85.9.76",
    type: "default",
    position: { x: 260, y: 380 },
    className: "gateway",
    data: { label: "193.85.9.76" },
    dragHandle: "noDrag",
  },
  {
    id: "217.31.205.50",
    type: "default",
    position: { x: 100, y: 310 },
    className: "gateway",
    data: { label: "217.31.205.50" },
    dragHandle: "noDrag",
  },
  {
    id: "82.208.6.9",
    type: "default",
    position: { x: 460, y: 300 },
    className: "gateway",
    data: { label: "82.208.6.9" },
    dragHandle: "noDrag",
  },
  {
    id: "2001:718:1202:240::201",
    type: "default",
    position: { x: 781, y: 594 },
    className: "gateway",
    data: { label: "2001:718:1202:240::201" },
    dragHandle: "noDrag",
  },
  {
    id: "222.173.190.239",
    type: "default",
    position: { x: 862, y: 197 },
    className: "gateway",
    data: { label: "222.173.190.239" },
    dragHandle: "noDrag",
  },
  {
    id: "45.87.28.93",
    type: "default",
    position: { x: 900, y: 451 },
    className: "gateway",
    data: { label: "45.87.28.93" },
    dragHandle: "noDrag",
  },
  {
    id: "208.67.222.222",
    type: "default",
    position: { x: 708, y: 237 },
    className: "gateway",
    data: { label: "208.67.222.222" },
    dragHandle: "noDrag",
  },
  {
    id: "57.200.0.1",
    type: "default",
    position: { x: 589, y: 373 },
    className: "gateway",
    data: { label: "57.200.0.1" },
    dragHandle: "noDrag",
  },
  {
    id: "2002:c0a8:101::1",
    type: "default",
    position: { x: 870, y: 335 },
    className: "gateway",
    data: { label: "2002:c0a8:101::1" },
    dragHandle: "noDrag",
  },
];
